import type { ErrorStatusType } from '@/app/types/error-layout';

interface ErrorData {
  title: string;
  description: string;
}

export const ERROR_PAGE_ATTRIBUTE = 'data-error-page';

export const ERROR_DATA: Record<ErrorStatusType, ErrorData> = {
  '404': {
    title: 'ขออภัย ไม่พบหน้า<span>ที่คุณกำลังหา</span>',
    description: 'Sorry, the page not found.',
  },
  '500': {
    title: 'ขออภัย ระบบขัดข้องชั่วคราว',
    description: 'Internal server error.',
  },
};

export const ERROR_IMAGE = {
  404: 'https://assets.isuzu-tis.com/error_404_5bee6d9daf.png',
  500: 'https://assets.isuzu-tis.com/error_500_19a9e078fa.png',
  NOT_SUPPORT: 'https://assets.isuzu-tis.com/not_support_f7e0571c35.png',
};
